(function () {
  function init() {
    var bar = document.querySelector('.sticky-atc');
    var realBtn = document.querySelector('#addToCart');
    if (!bar || !realBtn) return;

    var stickyBtn = bar.querySelector('.sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.disabled = !!realBtn.disabled;
      stickyBtn.addEventListener('click', function () {
        if (realBtn.disabled) return;
        realBtn.click();
      });
    }

    var buyBox = realBtn.closest('form');
    if (!buyBox || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry) return;
        // Only reveal once the buy box has been scrolled past (its top
        // edge has gone above the viewport) - not before it's been reached.
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      },
      { threshold: 0 }
    );
    observer.observe(buyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
